import { useState } from "react";

export type AuditFilters = {
  q: string;
  target_key: string;
  sort: "latest" | "oldest";
  start: string;
  end: string;
  pageSize: number;
  page: number;
};

const defaultFilters: AuditFilters = {
  q: "",
  target_key: "all",
  sort: "latest",
  start: "",
  end: "",
  pageSize: 20,
  page: 1,
};

// 이력 화면 필터 상태와 쿼리스트링 생성 로직을 한곳에서 관리한다.
export function useAuditFilters(initial?: Partial<AuditFilters>) {
  const [filters, setFilters] = useState<AuditFilters>({
    ...defaultFilters,
    ...(initial || {}),
  });

  return {
    filters,
    setFilters,
    // 단일 필드 업데이트 시 page 초기화 규칙을 함께 적용한다.
    updateFilter<K extends keyof AuditFilters>(key: K, value: AuditFilters[K]) {
      setFilters((prev) => {
        const nextPage = key === "page" ? Number(value) : 1;
        const next = {
          ...prev,
          [key]: value,
          page: nextPage,
        };
        if (
          next.q === prev.q &&
          next.target_key === prev.target_key &&
          next.sort === prev.sort &&
          next.start === prev.start &&
          next.end === prev.end &&
          next.pageSize === prev.pageSize &&
          next.page === prev.page
        ) {
          return prev;
        }
        return next;
      });
    },
    // 현재 필터 상태를 관리자 history API 호출용 URLSearchParams로 만든다.
    buildQuery() {
      const query = new URLSearchParams({
        q: filters.q,
        target_key: filters.target_key,
        sort: filters.sort,
        page: String(filters.page),
        pageSize: String(filters.pageSize),
      });
      if (filters.start) query.set("start", filters.start);
      if (filters.end) query.set("end", filters.end);
      return query;
    },
  };
}
